import axios from 'axios'
import { REACT_APP_API } from '../../config'
import * as FileSaver from 'file-saver'
import { XML_TYPE } from 'Utilities'

const FILE_NAME = 'usuarios.xlsx'

export async function getUsersReport() {
    const response = await axios(`${REACT_APP_API}/users/excel`, {
        method: 'GET',
        responseType: 'blob',
        timeout: 300000 // 5 minutos
      })

    const reportData = response.data
    const file = new Blob([reportData], {
        type: XML_TYPE
    })

    FileSaver.saveAs(file, FILE_NAME)

    return !!reportData
}
